import React from 'react'
import { Link } from 'react-router-dom';
import { SocialIconsData } from '../constants/data';

function SocialIconComponent({isVisible}) {
    return (
        SocialIconsData.map((item) => {
            return (
                <Link
                    key={item.id}
                    to={item.path}
                    target="_blank"
                    className={`${isVisible ? 'text-white ' : ''} w-8 h-8 rounded-full border hover:border-main hover:text-main transitions flex justify-center items-center`}
                >
                    <item.icon />
                </Link>
            );
        })
    )
}

export default SocialIconComponent
